import React from 'react';
import { CardTW } from '../../../../tailwindComponents/CardTW/CardTW';
import { SimpleGrid } from '../../../../tailwindComponents/grid/SimpleGrid';
import { HeaderTextTW } from '../../../../tailwindComponents/HeaderTextTW/HeaderTextTW';
import { HintTextTW } from '../../../../tailwindComponents/formCellTW/HintTextTW';
import { Show } from '../../../shared/Show';
import { ButtonTW } from '../../../../tailwindComponents/buttonTW/ButtonTW';
import { UserPlusIcon } from '@heroicons/react/24/outline';
import { BodyTextTW } from '../../../../tailwindComponents/bodyText/BodyTextTW';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query/react';
import { SerializedError } from '@reduxjs/toolkit';
import { ErrorMessageTW } from '../../../../tailwindComponents/errorMessage/ErrorMessageTW';

interface ContactDataTemplateProps {
  header: string;
  hintText?: string;
  addContact?: () => void;
  rtkError?: FetchBaseQueryError | SerializedError;
  children?: React.ReactNode;
}
export const ContactDataTemplate: React.FC<ContactDataTemplateProps> = ({
  addContact,
  children,
  header,
  hintText,
  rtkError,
}) => {
  return (
    <CardTW title={<ContactDataTemplateTitle addContact={addContact} header={header} hintText={hintText} />}>
      <ErrorMessageTW rtkError={rtkError} />
      <SimpleGrid>{children}</SimpleGrid>
    </CardTW>
  );
};

const ContactDataTemplateTitle: React.FC<ContactDataTemplateProps> = ({ header, hintText, addContact }) => {
  return (
    <div className={'flex flex-row items-center justify-between'}>
      <div>
        <HeaderTextTW>{header}</HeaderTextTW>
        <HintTextTW hintText={hintText}></HintTextTW>
      </div>
      <Show when={!!addContact}>
        <ButtonTW secondary className={'h-8'} onClick={addContact}>
          <div className={'flex flex-row items-center gap-2'}>
            <UserPlusIcon className={'h-4 w-4'} />
            <BodyTextTW>Add New Contact</BodyTextTW>
          </div>
        </ButtonTW>
      </Show>
    </div>
  );
};
